import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { usePermissions } from '@/hooks/usePermissions';
import { useLogout } from '@/hooks/useLogout';
import { Access, homePathFor } from '@/lib/permissions';
import { Button } from '@/components/ui/button';

interface RoleRouteProps {
    readonly access: Access;
    readonly children: React.ReactNode;
}

/**
 * Oculta pantallas según el rol. Es solo comodidad: el servidor rechaza igual lo que no corresponde.
 * Mientras el perfil no cargó no se decide nada (evita mandar a un admin a otra pantalla en un F5).
 */
export function RoleRoute({ access, children }: RoleRouteProps) {
    const { role, isLoaded, canAccess } = usePermissions();
    const { pathname } = useLocation();
    // Mismo cierre completo que el menú lateral (servidor + cache + store + login)
    const cerrarSesion = useLogout();

    if (!isLoaded) {
        return (
            <div className="flex h-64 items-center justify-center">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
        );
    }
    if (!canAccess(access)) {
        const destino = homePathFor(role);
        // Guarda anti-bucle: si el destino es la propia ruta, redirigir no termina nunca.
        if (destino === pathname) {
            return (
                <div className="flex h-64 flex-col items-center justify-center gap-4 text-center">
                    <p className="text-lg font-semibold">No tenés acceso a esta sección</p>
                    <Button variant="outline" onClick={() => void cerrarSesion()}>
                        Cerrar sesión
                    </Button>
                </div>
            );
        }
        return <Navigate to={destino} replace />;
    }
    return <>{children}</>;
}
